import { CaptureClicksRichText } from '@/features/shared/RichText';
import React, { memo } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const MarketoReCAPTCHA = React.forwardRef<any, any>((props: any, ref) => {
  const { size, badge, legal, sitekey, classes, theme, setRecaptchaFlag = () => {} } = props;

  return (
    <>
      <ReCAPTCHA
        ref={ref}
        size={size}
        badge={badge}
        sitekey={sitekey}
        onChange={() => setRecaptchaFlag(true)}
      />
      {legal && (
        <CaptureClicksRichText
          theme={theme}
          content={legal}
          containerProps={{ className: classes.recaptchaLegal }}
        />
      )}
    </>
  );
});

export default memo(MarketoReCAPTCHA);
